import { BillingState } from '../types/billing-state';

export default function formatBillingStateName(billingState: BillingState) {
    return billingState.name || `Lugar #${billingState.id}`;
}
